<template>
  <div class="leaderboard">
    <touch @tap="gotoRanking">
      <div v-show="joinedGroup" class="ranking">
        <h3>{{ myGroup.name }}</h3>
        <p class="info">第 <strong>{{ myGroup.ranking }}</strong> 名 · 累计捐赠 <strong>{{ duration2course(myGroup.duration) }}</strong> 节</p>
        <webp-image :src="myGroup.icon" alt="icon" />
      </div>
      <div v-show="!joinedGroup" class="title">
        <h4>英语流利说 × 美丽中国</h4>
        <h2>高校公益争霸赛</h2>
        <webp-image class="school-icon" src="https://cdn.llscdn.com/fe-static/lls-with-tfchina/school-HXC4xSHf.png" alt="school" />
      </div>
    </touch>
  </div>
</template>

<script>
  import actions from '@/store/action-types'

  import WebpImage from '@/components/common/WebpImage'

  export default {
    name: 'leaderboard',
    computed: {
      basicDonateDuration () {
        return this.$store.state.BASIC_DONATE_DURATION
      },
      joinedGroup () {
        return this.$store.state.leaderboard.joinedGroup
      },
      myGroup () {
        return this.$store.state.leaderboard.group.mine
      }
    },
    created () {
      this.getGroupLeaderboard()
    },
    methods: {
      duration2course (duration) {
        return Math.floor(duration / this.basicDonateDuration)
      },
      getGroupLeaderboard () {
        this.$store.dispatch(actions.fetch.GROUP_LEADERBOARD)
      },
      gotoRanking () {
        this.$track.sendActionTrack('csr_home', 'click_banner', {
          status: this.joinedGroup ? 1 : 0
        })
        this.$router.push({name: 'ranking', params: {tab: 'group'}})
      }
    },
    components: {
      WebpImage
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  .leaderboard {
    @include border-radius;
    width: 100%;
    height: 200px;
    background-color: $grey;
    .title {
      position: relative;
      padding-top: 50px;
      padding-left: 40px;
      height: 200px;
      h4 {
        font-size: 24px;
        color: rgba($black, 0.54);
        line-height: 33px;
      }
      h2 {
        margin-top: 5px;
        font-size: 44px;
        font-weight: normal;
        color: $black;
        line-height: 62px;
      }
      .school-icon {
        position: absolute;
        top: 16px;
        right: 43px;
        width: 223px;
        height: 169px;
      }
    }
    .ranking {
      position: relative;
      padding-top: 50px;
      padding-left: 40px;
      h3 {
        font-size: 36px;
        color: $black;
        line-height: 50px;
      }
      p {
        margin-top: 10px;
        font-size: 28px;
        color: rgba($black, 0.54);
        strong {
          color: $red;
          font-weight: normal;
        }
      }
      img {
        position: absolute;
        top: 40px;
        right: 40px;
        width: 120px;
        height: 120px;
        border-radius: 50%;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// Leaderboard.vue?5186ca15